export const useShoppingCartStore = defineStore("shoppingCart", () => {
  const isLoading = ref();
  const shoppingCartId = ref();
  const status = ref();
  const shopper = ref();
  const company = ref();

  const priceBreakdown = ref();

  const products = ref();
  const hotelRoomOffers = ref();
  const meetingRoomOffers = ref();
  const subscriptionOffers = ref();
  const paymentSessions = ref();

  const value = computed(() => {
    return {
      status: status.value,
      priceBreakdown: priceBreakdown.value,
      products: products.value,
      hotelRoomOffers: hotelRoomOffers.value,
      meetingRoomOffers: meetingRoomOffers.value,
      subscriptionOffers: subscriptionOffers.value,
      paymentSessions: paymentSessions.value,
    };
  });
  const rateInShoppingCartRequiresLogin = ref();
  const rateInShoppingCartRequiresSubscription = ref();

  function resetShoppingCart() {
    isLoading.value = undefined;
    shoppingCartId.value = undefined;
    status.value = undefined;
    shopper.value = undefined;
    priceBreakdown.value = undefined;
    products.value = undefined;
    hotelRoomOffers.value = undefined;
    meetingRoomOffers.value = undefined;
    paymentSessions.value = undefined;

    rateInShoppingCartRequiresLogin.value = undefined;
    rateInShoppingCartRequiresSubscription.value = undefined;

    document.cookie =
      "shoppingCartId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  function resetSubscriptionShoppingCart() {
    isLoading.value = undefined;
    shoppingCartId.value = undefined;
    status.value = undefined;
    shopper.value = undefined;
    priceBreakdown.value = undefined;
    products.value = undefined;
    hotelRoomOffers.value = undefined;
    paymentSessions.value = undefined;

    rateInShoppingCartRequiresLogin.value = undefined;
    rateInShoppingCartRequiresSubscription.value = undefined;

    document.cookie =
      "subscriptionShoppingCartId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  function getShoppingCartStoreObject() {
    return {
      status: status.value,
      priceBreakdown: priceBreakdown.value,
      products: products.value,
      hotelRoomOffers: hotelRoomOffers.value,
      meetingRoomOffers: meetingRoomOffers.value,
      subscriptionOffers: subscriptionOffers.value,
      paymentSessions: paymentSessions.value,
    };
  }

  return {
    value,
    isLoading,
    shoppingCartId,
    status,
    shopper,
    company,
    priceBreakdown,
    products,
    hotelRoomOffers,
    meetingRoomOffers,
    subscriptionOffers,
    paymentSessions,
    rateInShoppingCartRequiresLogin,
    rateInShoppingCartRequiresSubscription,
    resetShoppingCart,
    resetSubscriptionShoppingCart,
    getShoppingCartStoreObject,
  };
});
